import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ClimateCompensationCard } from "~/components/Login/components/ClimateCompensationCard/ClimateCompensationCard";
import { InstructionsCard } from "~/components/Login/components/InstructionsCard/InstructionsCard";
import { AppLayout } from "~/components/common/AppLayout/AppLayout";
import { ReturnsLayout } from "~/components/common/ReturnsLayout/ReturnsLayout";
import { ReturnsPolicy } from "../common/ReturnsPolicy/ReturnsPolicy";
import { SubHeader } from "~/components/common/SubHeader/SubHeader";

import { LoginForm } from "./components/LoginForm/LoginForm";
import { useLogin } from "./index.hook";

const Login: FC = () => {
  const { t } = useTranslation();

  const {
    orderId,
    customerEmail,
    setOrderId,
    setCustomerEmail,
    isDisableCTA,
    isLoading,
    isError,
    errorMessage,
    fetchOrder,
    name,
    climateCompensation,
    policyUrl,
  } = useLogin();
  // Note: we only display the card, if the title and either of the text is present
  const showInstructionsCard =
    t("backend:login_overview_header") &&
    (t("backend:login_overview_text_1") ||
      t("backend:login_overview_text_2") ||
      t("backend:login_overview_text_3"));

  return (
    <AppLayout size="sm">
      <ReturnsLayout renderFooter={() => <ReturnsPolicy url={policyUrl} />}>
        <SubHeader
          title={t("backend:login_header")}
          subTitle={t("backend:login_instructions")}
        />
        <div className="p-6 px-3 p-md-6">
          <LoginForm
            setOrderId={setOrderId}
            setCustomerEmail={setCustomerEmail}
            orderId={orderId}
            customerEmail={customerEmail}
            isLoading={isLoading}
            isError={isError}
            errorMessage={errorMessage}
            isDisableCTA={isDisableCTA}
            onSubmit={fetchOrder}
          />
        </div>
      </ReturnsLayout>
      {showInstructionsCard ? (
        <div className="mt-3">
          <InstructionsCard />
        </div>
      ) : null}
      {climateCompensation ? (
        <div className="mt-3">
          <ClimateCompensationCard merchantName={name} />
        </div>
      ) : null}
    </AppLayout>
  );
};

export default Login;
